<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_lettersSoundsSyllables') }}
        game-preview-setting(v-if="parameters.amountOfExamples")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_category_of_words') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_class_' + parameters.class) }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
    };
</script>
